<template>
  <div :style="style" @touchstart.stop @touchmove.stop @touchend.stop @touchcancel.stop></div>
</template>
<script>
// var debounce = require('lodash.debounce');
var monacoLoader = require("./loader");
export default {
  name: "MonacoEditor",
  props: {
    width: {
      type: [String, Number],
      default: "100%"
    },
    height: {
      type: [String, Number],
      default: "100%"
    },
    readOnly:{
      type:Boolean,
      default:false
    },
    code: {
      type: String,
      default: ""
    },
    srcPath: {
      type: String,
      default: ""
    },
    language: {
      type: String,
      default: "javascript"
    },
    theme: {
      type: String,
      default: "vs-dark"
    }, // vs, hc-black
    options: {
      type: Object,
      default: () => {}
    },
    changeThrottle: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      defaults: {
        selectOnLineNumbers: true,
        roundedSelection: false,
        readOnly: false,
        cursorStyle: "line",
        automaticLayout: false,
        glyphMargin: true,
      }
    };
  },
  computed: {
    style() {
      const { width, height } = this;
      const fixedWidth = width.toString().indexOf("%") !== -1 ? width : `${width}px`;
      const fixedHeight = height.toString().indexOf("%") !== -1 ? height : `${height}px`;
      return {
        width: fixedWidth,
        height: fixedHeight
      };
    },
    editorOptions() {
      return Object.assign({}, this.defaults, this.options, {
        // value: this.code,
        language: this.language,
        theme: this.theme,
        wrappingColumn: 0,
        wrappingIndent: "indent",
        autoIndent: "keep",
        insertSpaces: true,
        tabSize: 2
      });
    }
  },
  mounted() {
    this.fetchEditor();
  },
  destroyed() {
    this.destroyMonaco();
  },
  methods: {
    getContent() {
      return this.editor.getValue();
    },
    setContent(v) {
      if (this.editor) {
        this.editor.setValue(v);
      }
    },
    editorHasLoaded(editor, monaco) {
      this.editor = editor;
      this.monaco = monaco;
      this.editor.onDidChangeModelContent((event) => this.codeChangeHandler(editor, event));
      this.editor.onDidBlurEditorText((event) => this.codeBlurHandler(editor, event));
      this.$emit("mounted", editor);
    },
    codeChangeHandler: function (editor) {
      if (this.codeChangeEmitter) {
        this.codeChangeEmitter(editor);
      } else {
        this.codeChangeEmitter = _.debounce(function (editor) {
          this.$emit("codeChange", editor);
        }, this.changeThrottle);
        this.codeChangeEmitter(editor);
      }
    },
    codeBlurHandler: function (editor) {
      this.$emit("blur", editor);
    },
    fetchEditor() {
      monacoLoader.load(this.srcPath, this.createMonaco);
    },
    createMonaco() {
      let isDs = false;
      let isDSFContext = false;
      this.editor = window.monaco.editor.create(this.$el, this.editorOptions);
      this.editor.setValue(this.code||"");
      this.editorHasLoaded(this.editor, window.monaco);
      ["javascript"].map((item) => {
        window.monaco.languages.registerCompletionItemProvider(item, {
          provideCompletionItems(model, position) {
            const line = position.lineNumber;
            // 获取当前列数
            // const column = position.column
            // 获取当前输入行的所有内容
            const content = model.getLineContent(line);
            isDs = content.match(/\bds$/g);
            if (isDs) {
              return {
                suggestions: [
                  {
                    label: "dsf",
                    kind: window.monaco.languages.CompletionItemKind["Function"],
                    insertText: "dsf",
                    detail: ""
                  }
                ]
              };
            } else {
              isDSFContext = content.match(/\bdsf(\.|\.([$a-zA-Z_][$a-zA-Z0-9_]*)\.)$/g);
              if (isDSFContext) {
                let kinds = window.monaco.languages.CompletionItemKind;
                let arr = [];
                let obj = eval(isDSFContext[0].substr(0, isDSFContext[0].length - 1));
                if (obj) {
                  for (let k in obj) {
                    arr.push({
                      label: k,
                      kind: dsf.type(obj[k]) == "function" ? kinds["Function"] : kinds["Module"],
                      insertText: k,
                      detail: ""
                    });
                  }
                  return {
                    suggestions: arr
                  };
                } else {
                  return {
                    suggestions: arr
                  };
                }
              }
            }
          },
          triggerCharacters: ["."]
        });
      });
      // 监听键盘按键
      this.editor.onKeyDown((e) => {
        // 监听 Ctrl + S
        if (e.keyCode === window.monaco.KeyCode.KEY_S && (dsf.client.isMac ? e.metaKey : e.ctrlKey)) {
          e.preventDefault();
          this.$emit("saveCode");
        }
      });
      // this.editor.onDidContentSizeChange((event)=>{
      //   this.editor.layout();
      // })
    },
    insertContent(text) {
      if (this.editor) {
        let selection = this.editor.getSelection();
        let range = new monaco.Range(selection.startLineNumber, selection.startColumn, selection.endLineNumber, selection.endColumn);
        let op = { range: range, text: text, forceMoveMarkers: true };
        this.editor.executeEdits("", [op]);
        this.editor.focus();
      }
    },
    destroyMonaco() {
      if (typeof this.editor !== "undefined") {
        this.editor.dispose();
      }
    },
    layout() {
      this?.editor?.layout?.();
    }
  }
};
</script>
